import React from "react";

const Stars = ({ size = "1.5em", color = "gold" }) => {
  return <span style={{ color, fontSize: size }}>&#9733;</span>;
};

export default Stars;
